import React, { useCallback, useEffect, useRef } from 'react';

import { IframeDataAdaptedType, ThreeDSAuthResult } from '../../types';
import LoadingModal from '../LoadingModal';
import { isThreeDSOne, isThreeDSTwoAuth, isThreeDSTwoPay } from './helpers/threeDSSteps';
import useThreeDSAuth from './hooks/useThreeDSAuth';

type Props = {
  iframeData: IframeDataAdaptedType;
  onResult: (result: ThreeDSAuthResult) => void;
  onError: VoidFunction;
  submitTarget: string;
};

function ThreeDSForm({ iframeData, onResult, onError, submitTarget }: Props) {
  const submitFormRef = useRef<HTMLFormElement | null>(null);
  const isThreeDS2AuthFlow = Boolean(isThreeDSTwoAuth(iframeData));

  useEffect(() => {
    if (submitFormRef && submitFormRef?.current && iframeData) {
      submitFormRef.current.submit();
    }
  }, [iframeData, submitFormRef]);

  useThreeDSAuth({ iframeData, onResult, onError });

  const threeDsForm = useCallback(() => {
    let fields: Record<string, any> = {};

    if (isThreeDSTwoAuth(iframeData)) {
      const { threeDSMethodData } = iframeData;
      fields = { threeDSMethodData };
    }

    if (isThreeDSOne(iframeData)) {
      const { PaReq, MD, TermUrl } = iframeData;
      fields = { PaReq, MD, TermUrl };
    }

    if (isThreeDSTwoPay(iframeData)) {
      const { creq, threeDSSessionData } = iframeData;
      fields = { creq, threeDSSessionData };
    }

    return Object.keys(fields).map((key) => (
      <input key={key} type="hidden" name={key} value={fields[key]} />
    ));
  }, [iframeData]);

  return (
    <>
      <form method="post" target={submitTarget} action={iframeData.action} ref={submitFormRef}>
        {threeDsForm()}
      </form>

      <LoadingModal isOpen={isThreeDS2AuthFlow} />
    </>
  );
}

export default ThreeDSForm;
